import { sendRequest } from "../libs/axiosConfig";

const initialQueryObj = {
  query: "",
  currentPage: 1,
  pageSize: 20,
};

export const getSectorCategoryProductsApi = async (
  queryObj = initialQueryObj
) => {
  const {
    query = "",
    currentPage = 1,
    pageSize = 10,
    sectorCategory = "",
  } = queryObj;
  const { data } = await sendRequest({
    url: `/api/v1/products/category?q=${query}&sectorCategory=${sectorCategory}&page=${currentPage}&pageSize=${pageSize}`,
  });
  return { data: data };
};
